import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import global from "./modules/global";
import restaurant from "./modules/restaurant";
import auth from "./modules/auth";
import localization from "./modules/localization";
import chat from "./modules/chat";
import order from "./modules/order";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        global,
        restaurant,
        auth,
        localization,
        chat,
        order
    },
    plugins: [createPersistedState({
        paths: [
            'localization',
            'auth',
            'order',
            'restaurant'
        ]
    })]
});

export default store;
